import { glossary as magicGlossary, faq as magicFaq } from '../gameContent/magic';
import { glossary as pokemonGlossary, faq as pokemonFaq } from '../gameContent/pokemon';
import { glossary as digimonGlossary, faq as digimonFaq } from '../gameContent/digimon';
import { glossary as yugiohGlossary, faq as yugiohFaq } from '../gameContent/yugioh';
import { glossary as grandArchiveGlossary, faq as grandArchiveFaq } from '../gameContent/grand-archive';

export interface GameToolData {
  glossary: { term: string; definition: string; category?: string }[];
  faq: { q: string; a: string }[];
}

export const gameDataRegistry: Record<string, GameToolData> = {
  "4": { glossary: magicGlossary, faq: magicFaq },
  "magic": { glossary: magicGlossary, faq: magicFaq },
  "3": { glossary: pokemonGlossary, faq: pokemonFaq },
  "pokemon": { glossary: pokemonGlossary, faq: pokemonFaq },
  "9": { glossary: yugiohGlossary, faq: yugiohFaq },
  "yugioh": { glossary: yugiohGlossary, faq: yugiohFaq },
  "2": { glossary: digimonGlossary, faq: digimonFaq },
  "digimon": { glossary: digimonGlossary, faq: digimonFaq },
  "16": { glossary: grandArchiveGlossary, faq: grandArchiveFaq },
  "grand-archive": { glossary: grandArchiveGlossary, faq: grandArchiveFaq },
  "grandarchive": { glossary: grandArchiveGlossary, faq: grandArchiveFaq },
  // Add other games as needed
};

export const getGameData = (gameId: string | number | 'All' | null | undefined): GameToolData | null => {
  if (!gameId || gameId === 'All') return null;
  const key = gameId.toString().toLowerCase();
  return gameDataRegistry[key] || null;
};
